module.exports = __webpack_public_path__ + "img/waiting.5e789de0.svg";